import { Component, OnInit } from '@angular/core';
import { BpgMembershipService } from '../bpg-membership.service';
import { DataService, bpgs, interests, skills, membershipFormData, leadership, LandingDTOModel, FilterModel, site } from "../../bpg-common/services/data.services";
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';
@Component({
  selector: 'app-bpg-list',
  templateUrl: './bpg-list.component.html',
  styleUrls: ['./bpg-list.component.css']
})

export class BpgListComponent implements OnInit {
  selectedBpg: any[] = [];
  bpgList: any[] = [];
  savedData: any;
  formData: membershipFormData[];
  interestList: interests[];
  skillsList: skills[];
  siteList: site;
  leadershipList: leadership = new leadership();
  message: String;
  demographicsList: any[] = [];
  otherSKills: string;
  membershipDetails: any[] = [];
  userId: number = 1;
  loginData: any;
  loginUserId: any[] = [];
  savedMembershipForm: any;
  landingDTOModel: LandingDTOModel = new LandingDTOModel();
  siteId1: any = localStorage.getItem('userSiteId');
  filter: FilterModel = new FilterModel();
  timeOutError: boolean;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  nobpgfound: boolean = false;
  virtualBpg: boolean;

  corporateType: string;
  isCorporateUser: boolean = false;
  showLeadership: boolean = false; 
  bpgName : any;
  roleList : any[] = [];
  chairs : any = [] ;
  viceChairs : any = []  ;
  communicationsChairs: any= [] ;
  financeChairs: any  = [];
 leadershipObj :  any ;
 newList = {};
 finalList : any[] = [];
 
  /**
   * @class BpgListComponent
   * @constructor
   */
  constructor(private membershipService: BpgMembershipService,
    private data: DataService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    
    private environment: EnvironmentConfiguration) { }

  ngOnInit() {
    localStorage.setItem('oneSkill', 'false');
    if (this.environment.envName == 'dev' || this.environment.envName == 'qa' || this.environment.envName == 'prod') {
              if (localStorage.getItem('loginData')== null || localStorage.getItem('loginData')== undefined) {

        this.router.navigate(['/log-out']);
      }
    }
    window.scrollTo(0, 0);

    localStorage.removeItem('searchedEventsCaledarItems');
    this.loginData = JSON.parse(localStorage.getItem('loginData'));
    this.corporateType = (this.loginData.corporatePartnerType !== null && this.loginData.corporatePartnerType !== undefined) ? this.loginData.corporatePartnerType.trim() : '';
    if (this.corporateType.toUpperCase() == "CONTINGENT" || this.corporateType.toUpperCase() == "TECHNICAL CONTRACTOR") {
      this.isCorporateUser = true;
    }  
 




    this.formData = [];
    this.savedData = JSON.parse(sessionStorage.getItem('MembershipData'));
    if (this.savedData == null) {
      this.savedData = "default msg"
    }

    this.spinnerService.show();
    if (this.savedData[0].virtualBpg != undefined) {
      this.virtualBpg = this.savedData[0].virtualBpg;
    } else {
      this.virtualBpg = undefined;
    }
    if (this.savedData[0].siteFormData != undefined) {
      this.siteList = this.savedData[0].siteFormData;
    } else {
      this.siteList = null;
    }
    if (this.savedData[0].interestFormData != undefined) {
      this.interestList = this.savedData[0].interestFormData;
    } else {
      this.interestList = [];
    }
    if (this.savedData[0].skillsFormData != undefined) {
      this.skillsList = this.savedData[0].skillsFormData;
    } else {
      this.skillsList = [];
    }
    if (this.savedData[0].leadershipFormData != undefined) {
      this.leadershipList = this.savedData[0].leadershipFormData;
    } else {
      this.leadershipList = null;
    }
    if (this.savedData[0].otherSkillsFormData != undefined) {
      this.otherSKills = this.savedData[0].otherSkillsFormData;
    } else {
      this.otherSKills = null;
    }
    this.getBpgDetails();
  }

  


  /** To async the service call to get the bpg list with selected bpgs
   * @class BpgListComponent
   * @method getBpgDetails
   */
  async getBpgDetails() {
    console.log(this.virtualBpg);
    if (this.virtualBpg) {
      await this.getVirtualBpgs();
    } else {
      await this.getBpgs();
    }
  }

  /** To async the service call to get the bpg list
   * @class BpgListComponent
   * @method getBpgs
   */
  async getBpgs() {
    this.filter.siteId = String(this.siteList.siteId);
    this.landingDTOModel.filter = this.filter;
    await this.membershipService.getAllBpg(this.landingDTOModel).toPromise().then(async data => {
      
      this.bpgList = data;

     
     
      console.log('Site Selected List :: ', [...data]);
      if (this.bpgList.length > 0) {
        this.nobpgfound = false;
      }
      else {
        this.nobpgfound = true;
      }
      await this.getSelectedBpgs();
    }, err => {
      this.spinnerService.hide();
      console.log(JSON.stringify(err.value.message));
      if (err.value.statusText == ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }

  /** To async the service call to get the bpg list of default site
   * @class BpgListComponent
   * @method getBpgs
   */
  async getVirtualBpgs() {
    const params = `${this.siteList.siteId}/${this.siteId1}/${this.loginData.userId}`;
    console.info(params);
    await this.membershipService.getAllVirtualBpg(params).toPromise().then(async data => {
      this.bpgList = data;
      console.log('Site Virtual List :: ', [...data]);
      if (this.bpgList.length > 0) {
        this.nobpgfound = false;
      } else {
        this.nobpgfound = true;
      }
      await this.getSelectedBpgs();
    }, err => {
      this.spinnerService.hide();
      console.log(JSON.stringify(err.value.message));
      if (err.value.statusText == ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }
  /** To async the service call to get the selected bpg list
   * @class BpgListComponent
   * @method getSelectedBpgs
   */
  async getSelectedBpgs() {
    await this.membershipService.retrieveDetailsOfMembership(this.loginData.userId).toPromise().then(data => {
      this.membershipDetails = data;
      console.log('Retrive :: ', JSON.stringify(this.membershipDetails));
      sessionStorage.setItem("previousMembershipDetails", JSON.stringify(this.membershipDetails));

      if (this.savedData[0].bpgFormData != undefined && this.savedData[0].bpgFormData.length > 0) {
        for (let i = 0, len = this.bpgList.length; i < len; i++) {
          for (let j = 0, len = this.savedData[0].bpgFormData.length; j < len; j++) {
            if (this.bpgList[i].bpgId == this.savedData[0].bpgFormData[j].bpgId) {
              this.bpgList[i].checked = true;
              this.selectedBpg.push(this.bpgList[i]);
            }
          }
        }
      }
      if (this.savedData[0].bpgFormData != undefined && this.savedData[0].bpgFormData.length > 0) {
        for (var j = 0 ; j < this.savedData[0].bpgFormData.length ; j++)
        { 
           var bpgname = this.savedData[0].bpgFormData[j].bpgName;
        if(this.selectedBpg[j].bpgName == bpgname)
          {this.selectedBpg[j].showLeadership =true;
          this.chairs[bpgname] = this.savedData[0].bpgFormData[j].chairs;
          this.selectedBpg[j].chairs = this.savedData[0].bpgFormData[j].chairs;
          this.viceChairs[bpgname] = this.savedData[0].bpgFormData[j].viceChairs;
          this.selectedBpg[j].viceChairs = this.savedData[0].bpgFormData[j].viceChairs;
          this.communicationsChairs[bpgname] = this.savedData[0].bpgFormData[j].communicationsChairs;
          this.selectedBpg[j].communicationsChairs = this.savedData[0].bpgFormData[j].communicationsChairs;
          this.financeChairs[bpgname] = this.savedData[0].bpgFormData[j].financeChairs;
          this.selectedBpg[j].financeChairs = this.savedData[0].bpgFormData[j].financeChairs;
        }
        }
    }
    console.log(this.selectedBpg.length)
    console.log(this.selectedBpg)
    if(this.membershipDetails['selectedBpg'].length > 0 && (this.membershipDetails['selectedBpg']!= undefined && this.membershipDetails['selectedBpg']!= null) &&  this.savedData[0].bpgFormData.length==0)
    {
      var selectList = this.bpgList;
      console.log(selectList)
      
      for(var i = 0; i< this.membershipDetails['selectedBpg'].length; i++)
      { 
        for(var j = 0; j<selectList.length; j++)
        { 
  
          if(this.membershipDetails['selectedBpg'][i].bpgName == selectList[j].bpgName)
          {
            selectList[j].chairs = this.membershipDetails['selectedBpg'][i].isChair;
            selectList[j].viceChairs = this.membershipDetails['selectedBpg'][i].isViceChair;
            selectList[j].communicationsChairs = this.membershipDetails['selectedBpg'][i].isCommunicationChair;
            selectList[j].financeChairs = this.membershipDetails['selectedBpg'][i].isFinanceChair;
            this.chairs[selectList[j].bpgName] = this.membershipDetails['selectedBpg'][i].isChair;
            this.viceChairs[selectList[j].bpgName] = this.membershipDetails['selectedBpg'][i].isViceChair;
            this.communicationsChairs[selectList[j].bpgName]  = this.membershipDetails['selectedBpg'][i].isCommunicationChair;
            this.financeChairs[selectList[j].bpgName] = this.membershipDetails['selectedBpg'][i].isFinanceChair;
            selectList[j].showLeadership=true;
            selectList[j].checked=true;
            this.selectedBpg.push(selectList[j])
          }
        }

      }
    }
    console.log(this.selectedBpg)
      if (this.membershipDetails['bpgIds'].length > 0 && this.savedData[0].bpgFormData.length<0) {
        for (let i = 0, len = this.bpgList.length; i < len; i++) {
          for (let j = 0, len = this.membershipDetails['bpgIds'].length; j < len; j++) {
            if (this.bpgList[i].bpgId == this.membershipDetails['bpgIds'][j]) {
             var bname = this.bpgList[i].bpgName;
              this.bpgList[i].checked = true;
              this.bpgList[i].showLeadership = true;
           
              this.selectedBpg.push(this.bpgList[i]);
            }
          }
        }
      }

      console.log(this.selectedBpg.length)
      console.log(this.membershipDetails['selectedBpg'].length )
  
      this.spinnerService.hide();
    }, err => {
      this.spinnerService.hide();
      console.log(JSON.stringify(err.value.message));
      if (err.value.statusText == ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });
  }

  /** To send data to next page
   * @class BpgListComponent
   * @method sendData
   */
  public sendData() {
    // Removing the validation for Virtual BPG
    // if (this.selectedBpg.length < 1) {
    //   this.message = "*Please select atleast one BPG";
    //   return
    // }
    this.formData.push({ virtualBpg: this.savedData[0].virtualBpg, siteFormData: this.siteList, bpgFormData: this.selectedBpg, interestFormData: this.interestList, skillsFormData: this.skillsList, leadershipFormData: this.leadershipList, otherSkillsFormData: this.otherSKills });
    // demographic code comment
    // this.formData.push({ bpgFormData: this.selectedBpg, interestFormData: this.interestList, skillsFormData: this.skillsList, leadershipFormData: this.leadershipList, demographicsFormData: this.demographicsList, otherSkillsFormData: this.otherSKills });
    sessionStorage.setItem("MembershipData", JSON.stringify(this.formData));
    this.router.navigate(['membership/interests']);
    window.scrollTo(0, 0);


  }



assignroles(event,data)
{
var bpgName = data.bpgName;
if(event.target.checked)
{
  for (var i = 0 ; i < this.selectedBpg.length ; i++)
  {
    if(bpgName = this.selectedBpg[i].bpgName)
    {
    if(this.chairs[bpgName])
    this.selectedBpg[i].chairs = true;
    if(this.viceChairs[bpgName])
    this.selectedBpg[i].viceChairs = true;
    if(this.communicationsChairs[bpgName])
    this.selectedBpg[i].communicationsChairs = true;
    if(this.financeChairs[bpgName])
    this.selectedBpg[i].financeChairs = true;
    }
  }
}

else{
  for (var i = 0 ; i < this.selectedBpg.length ; i++)
  {
    if(bpgName = this.selectedBpg[i].bpgName)
    {
    if(!this.chairs[bpgName])
    this.selectedBpg[i].chairs = false;
    if(!this.viceChairs[bpgName])
    this.selectedBpg[i].viceChairs = false;
    if(!this.communicationsChairs[bpgName])
    this.selectedBpg[i].communicationsChairs = false;
    if(!this.financeChairs[bpgName])
    this.selectedBpg[i].financeChairs = false;
    }
  }
 
}
console.log(this.selectedBpg)
}


  /** to select the checkbox
   * @class BpgListComponent
   * @method toggleCheckbox
   */
  toggleCheckbox(event, data) {  

    if (event.target.checked) {
      this.selectedBpg.push(data);
      for (var i = 0 ; i < this.bpgList.length ; i++)
      {
 
       if( this.bpgList[i].bpgName == data.bpgName)
       {
         this.bpgList[i] = Object.assign(this.bpgList[i], {
           'showLeadership' : true,
         })
     
 }}
    
      for(var j = 0 ; j < this.selectedBpg.length ; j++)
      {
        if( this.selectedBpg[j].bpgName == data.bpgName){
          this.selectedBpg[j] = Object.assign(this.selectedBpg[j], {
            chairs : false,communicationsChairs: false , financeChairs :false, viceChairs : false
  })
        }
      }
     
 
   } else {
      const index: number = this.selectedBpg.indexOf(data);
      if (index !== -1) {
      

        this.selectedBpg.splice(index, 1);
       for (var i = 0; i < this.bpgList.length ; i++){
        if(this.bpgList[i].bpgName == data.bpgName)
        {
         this.bpgList[i] = Object.assign(this.bpgList[i], {
            'showLeadership' : false,
      }) }
   
     
      }
     
      }
    }

  }

  /** To send data to previous page
   * @class BpgListComponent
   * @method redirectToSite
   */
  public redirectToSite() {
    localStorage.setItem('status', 'true');
    this.formData.push({ virtualBpg: this.savedData[0].virtualBpg, siteFormData: this.siteList, bpgFormData: this.selectedBpg, interestFormData: this.interestList, skillsFormData: this.skillsList, leadershipFormData: this.leadershipList, otherSkillsFormData: this.otherSKills });
    // demographic code comment
    // this.formData.push({ bpgFormData: this.bpgList, interestFormData: this.selectedInterest, skillsFormData: this.skillsList, leadershipFormData: this.leadershipList, demographicsFormData: this.demographicsList, otherSkillsFormData: this.otherSKills });
    //this.data.saveData(this.formData);
    sessionStorage.setItem("MembershipData", JSON.stringify(this.formData));
    window.scrollTo(0, 0);
  }
}
